import { Component } from "react";

import appSettings from "./settings/appSettings";
import ErrorInfo from "./views/ErrorInfoBaseComponent";

export class AppErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    this.setState((state) => {
      try {
        // Add class to html element to style error page
        window?.document?.querySelector("body")?.classList.add("page-app-error");
      } catch {
        /* empty */
      }

      return { ...state, error };
    });
  }

  render() {
    if (this.state.hasError) {
      if (this?.state?.error) {
        const { wvusLogger } = appSettings;
        wvusLogger.log(`Error: ${this.state.hasError}`, wvusLogger.getLogLevelNames().ERROR);
        console.error(this.state.error);
      }

      // You can render any custom fallback UI
      return (
        <ErrorInfo
          errorType="general"
          errorCode="error"
          errorMessage="Something went wrong"
          errorKey="errorBoundary"
        />
      );
    }

    return this?.props?.children || null;
  }
}

export function appErrorWrapper(WrappedComponent) {
  return class AppWrapper extends Component {
    render() {
      const props = this.props || {};

      return (
        <AppErrorBoundary>
          <WrappedComponent {...props} />
        </AppErrorBoundary>
      );
    }
  };
}

export default appErrorWrapper;
